import axios from 'axios'

const axiosInstance = axios.create()

export const getApiErrorPayload = (error, fallbackMessage = 'Something went wrong!') => {
    const payload = error?.response?.data || error?.apiData

    if (payload && typeof payload === 'object') {
        return payload
    }

    return {
        error: 'Client Error',
        errorInfo: String(payload || error?.message || fallbackMessage),
        result: 'error',
    }
}

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        const payload = error?.response?.data

        // Сохраняем стандартный AxiosError (status/config/headers), но оставляем
        // совместимость со старым кодом, который читает e.error/e.errorInfo.
        if (payload && typeof payload === 'object') {
            error.apiData = payload
            ;['error', 'errorInfo', 'result', 'message'].forEach((key) => {
                if (error[key] === undefined && payload[key] !== undefined) {
                    error[key] = payload[key]
                }
            })
        }

        return Promise.reject(error)
    }
)

export default axiosInstance
